<template>
    <div>
        <VueDatePicker v-model="date"></VueDatePicker>
    </div>
</template>